<template>
  <!-- 文本二次封装
      @author: liuguisheng
      @date: 2019-9-13
  -->
  <div class="form-item_text"
        :style="{ 
          width,
          fontSize: title + 'px',
          fontWeight: wordWeight,
          color: color,
          'padding-left': paddingLeft
        }">
        {{labelName}}
  </div>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixFormItemTemplateChild 表单项子级混入
 */
import { mixFormItemTemplateChild } from "@/mixins/form_item/mix_form_item_template_child.js";


export default {
  mixins: [ mixFormItemTemplateChild ]
}

</script>


// WEBPACK FOOTER //
// src/components/form_item/FormItemText.vue